import { render, staticRenderFns } from "./AdminIdTag.vue?vue&type=template&id=5a6683b6"
import script from "./AdminIdTag.vue?vue&type=script&lang=js"
export * from "./AdminIdTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports